module.exports = __webpack_public_path__ + "img/w78b.892961ce.jpg";